import { z } from 'zod';

/**
 * Purchase order ID validation schema
 * - Must be a non-empty string
 * - Automatically trims whitespace
 */
const purchaseOrderIdSchema = z
    .string()
    .min(1, 'Purchase order ID is required')
    .trim()
    .transform((val) => val.trim());
/**
 * Mark Backfill Inventory form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markBackfillInventoryFormSchema)
 */
const markBackfillInventoryFormSchema = z.object({
    purchaseOrderId: purchaseOrderIdSchema,
});

export { markBackfillInventoryFormSchema, purchaseOrderIdSchema };
//# sourceMappingURL=inventoryValidation.js.map
